import { forwardRef } from "react";

const base =
  "inline-flex items-center justify-center gap-2 font-sans text-[11px] uppercase tracking-label transition-colors duration-500 rounded-none disabled:opacity-40 disabled:pointer-events-none";

const variants = {
  primary:
    "bg-warm text-ink px-8 py-4 hover:bg-transparent hover:text-warm border border-warm",
  outline:
    "bg-transparent text-warm px-8 py-4 border border-charcoal hover:border-warm",
  ghost: "bg-transparent text-warm px-0 py-2",
};

const Button = forwardRef(function Button(
  { as = "button", variant = "primary", className = "", children, ...props },
  ref
) {
  const Tag = as;
  return (
    <Tag ref={ref} className={`${base} ${variants[variant]} ${className}`} {...props}>
      {children}
    </Tag>
  );
});

export default Button;
